<template>
    <button
        :class="[
            'scope-navigation-tab',
            { '-selected': selected, '-not-active': notActive }
        ]"
        @click="openPage(page)"
    >
        <div class="scope-navigation-tab__icon-wrapper">
            <Icon :icon="icon" class="scope-navigation-tab__icon" />
        </div>
        <span v-if="isFull" class="scope-navigation-tab__text">
            {{ tabName }}
        </span>
    </button>
</template>
<script setup>
import Icon from './Icon.vue';
defineProps({
    icon: String,
    tabName: String,
    selected: Boolean,
    notActive: Boolean,
    isFull: { type: Boolean, default: true },
    page: String
});

const emit = defineEmits(['openPage']);

const openPage = (page) => {
    emit('openPage', page);
};
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-navigation-tab {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 10px;
    background: $card-background;
    outline: 0;
    border: 0;
    cursor: pointer;

    &:hover {
        background-color: $card-neutral-background;

        .scope-navigation-tab__text {
            color: $text-high-emphasis;
        }
    }

    &__icon-wrapper {
        display: flex;
        width: 20px;
        min-width: 20px;
        height: 20px;
        justify-content: center;
        align-items: center;
    }

    &__icon {
        color: $icons-mid-emphasis;
    }

    &__text {
        display: inline-block;
        color: $text-mid-emphasis;
        @include fz-14;
        font-weight: 600;
        text-wrap: nowrap;
    }

    &.-selected {
        background-color: $card-background;
        border: 1px solid $border;
        @include shadow-small;

        .scope-navigation-tab__text {
            color: $text-high-emphasis;
        }

        .scope-navigation-tab__icon {
            color: $primary-accent;
        }
    }

    &.-not-active {
        pointer-events: none;

        .scope-navigation-tab__text {
            color: $text-low-emphasis;
        }

        .scope-navigation-tab__icon {
            color: $text-low-emphasis;
        }
    }
}
</style>
